import { ValidatorFn, AbstractControl } from '@angular/forms';
import { ValidationErrorDetails } from '../validation-error-details';
import { ArrayContainsValidatorParams } from './array-contains-validator-params';
import { ArrayContainsValidatorResult } from './array-contains-validator-result';

export function arrayContainsValidator(params: ArrayContainsValidatorParams): ValidatorFn {
  return (control: AbstractControl): ArrayContainsValidatorResult | null => {
    const result = new ArrayContainsValidatorResult();

    if (params.array.some((x) => params.predicate(x, control.value))) {
      result.arrayContains = new ValidationErrorDetails(true, params);
      return result;
    }

    return null;
  };
}
